enum iconNames {
    downArrowIcon = 'downArrowIcon'
}

export default iconNames;
